import React from 'react'
import './Favorite.css'

function FavoriteItem({FavData}) {
  return (
    <div>{FavData }</div>
  )
}

export default FavoriteItem